<template>
    <v-footer
    class="justify-center pa-n12 mt-10"
    color="#EAE6E9"
    height="200"
    app
    style="background-color: rgba(255, 255, 255, 0.6)">
    <v-row class="mb-0 pa-0">
      <v-col md="11">
        <v-row class="ma-0">
          <v-col cols="9">
            <p class="fMontserrat font-weight-light" style="font-size: 20px">
              {{ t("textoVisitaIndo") }} <span class="cursorPointer" @click="openUrl('https://indo.es/es/')">indo.es</span>
            </p>
            <span class="fMontserrat mt-n2 font-weight-light" style="font-size: 20px"
              >{{ t("followUs") }}
              <Icon
                icon="uil:facebook"
                style="font-size: 20px"
                class="mr-2 ml-5 cursorPointer"
                @click="openUrl('https://www.facebook.com/IndoEspana/?locale=es_ES')" />
              <Icon
                icon="uil:instagram-alt"
                style="font-size: 20px"
                class="mr-2 cursorPointer"
                @click="openUrl('https://www.instagram.com/indo_optical/')" />

              <!-- <Icon
            icon="fa6-brands:square-x-twitter"
            style="font-size: 20px"
            class="mr-2"
            @click="
              openUrl(
                'https://www.linkedin.com/company/indooptical/mycompany/'
              )
            "
          /> -->
              <Icon
                icon="uil:linkedin"
                style="font-size: 20px"
                class="mr-2 cursorPointer"
                @click="openUrl('https://www.linkedin.com/company/indooptical/mycompany/')" />
            </span>
          </v-col>
        </v-row>
        <v-row class="ma-0 d-flex justify-start ml-3"> </v-row>
        <v-row class="ma-0">
          <v-col md="2">
            <span class="fMontserrat text-center" style="font-size: 14px">INDO OPTICAL S.L.U © 2024</span>
          </v-col>
          <v-divider vertical color="black" />
          <v-col md="2" class="d-flex justify-center" v-for="(pol, index) in politicas" :key="index">
            <span class="fMontserrat text-center cursorPointer" style="font-size: 14px" @click="openUrl(pol.url)">{{ pol.texto }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script setup>

import { Icon } from "@iconify/vue";
import { ref } from "vue";
import { t } from "../functions/translation.js";



const politicas = ref([
  { texto: t("privacyPolicy"), url: "https://indo.es/es/privacy" },
  { texto: t("legalWarning"), url: "https://indo.es/es/legal" },
  { texto: "Cookies", url: "https://indo.es/es/cookies" },
//   { texto: t("integratedPolicy"), url: "https://indo.es/docs/politica_integrada_2022.pdf" },
//   { texto: t("complaintSystem"), url: "https://indooptical.integrityline.com/frontpage" },
]);

const openUrl = (url) => {
  window.open(url, "_blank");
};
</script>